//@ts-check
//@ts-ignore
import InformOwner from './inform-owner.riot';
import { connect } from '@/common/lib/riot-redux';
import { ajaxPost } from '../ajax';
import { getInformFailure, getInformRequest, getInformSuccess, informOwnerFailure, informOwnerRequest, informOwnerSuccess } from './inform-owner.action';

const mapStateToProps = (state) => {
  const dateStr = state.app.date.toString();
  const year = dateStr.substring(0, 4);
  const month = Number(dateStr.substring(4, 6));
  const day = Number(dateStr.substring(6, 8));
  return {
    key: state.app.key,
    status: state.app.status,
    msgText: state.app.msgText,
    date: year + '/' + month + '/' + day
  };
};

const mapDispatchToProps = (dispatch) => ({
  async init(key) {
    dispatch(getInformRequest());
    try {
      const res = await ajaxPost('/informowner', {
        method: 'getInform',
        key: key
      });
      dispatch(getInformSuccess(res));
    } catch (e) {
      dispatch(getInformFailure(e));
    }
  },

  async send(data) {
    dispatch(informOwnerRequest());
    try {
      const res = await ajaxPost('/informowner', {
        method: 'send',
        ...data
      });

      dispatch(informOwnerSuccess(res));
    } catch (e) {
      dispatch(informOwnerFailure(e));
    }
  }
});
export default connect(InformOwner, mapStateToProps, mapDispatchToProps);